export const frequencyMapping: { [key: number]: string } = {
  1: 'Weekly',
  2: 'Fortnightly',
  4: 'Monthly',
}
